import React from 'react'
import Hero from './Hero'
import HumanCapital from './HumanCapital'
import OurTeam from "./OurTeam";

const AboutHome = () => {
  return (
    <div>
        <Hero/>
        <OurTeam/>
    </div>
  )
}

export default AboutHome